import { useTmapLogContext } from '@/providers'
import { useCallback } from 'react'
import { logWithTag } from '@/utils'

const LOG = logWithTag('log.fn')

type SendEventLog = {
  actionId?: string;
  custom?: any;
  pageId?: string;
  isSkip?: boolean;
}

function useSendEventLog() {
  const { tmapLogClient } = useTmapLogContext()

  return useCallback((options: SendEventLog) => {
    const { actionId, custom, pageId, isSkip } = options
    const log = !pageId ? tmapLogClient('event') : tmapLogClient('event').setPageId(pageId)

    if (actionId) {
      log.setActionId(actionId)
    }
    if (custom) {
      Object.keys(custom).forEach((key) => {
        log.setCustom(key, custom[key])
      })
    }
    log.send({ skip: { logbox: isSkip } }).then(() => {
      LOG('sendEvent ', { actionId, custom })
    })
  }, [tmapLogClient])
}

export { useSendEventLog }
